import { render, staticRenderFns } from "./ModalRelatorio.vue?vue&type=template&id=1176b4ca&"
import script from "./ModalRelatorio.vue?vue&type=script&lang=js&"
export * from "./ModalRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./ModalRelatorio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports